import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#E2E7F0"
      d="M25 28H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h12l7 7v16a1 1 0 0 1-1 1"
    />
    <path
      fill="#8F9BA8"
      fillRule="evenodd"
      d="M7 3h12a1 1 0 0 1 .707.293l7 7 .007.006a1 1 0 0 1 .28.584v.002A1 1 0 0 1 27 11v16a1.997 1.997 0 0 1-2 2H7a2 2 0 0 1-2-2V5a1.997 1.997 0 0 1 2-2m16.585 7L20 6.415V10zM18 5v6a1 1 0 0 0 1 1h6v15H7V5z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconFileGeneric = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconFileGeneric);
export default Memo;
